export default function ContactSection() {
  return (
    <section id="contact" className="relative py-16 md:py-20 bg-background-100">
      <div className="mx-auto max-w-[1440px] px-4 md:px-6">
        <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-background-200 via-background-200 to-primary-500/5 border border-background-300/30 p-8 md:p-12">
          <div className="relative z-10 flex flex-col lg:flex-row items-center gap-8 md:gap-12">
            <div className="flex-1 text-center lg:text-left">
              <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading mb-3">联系我们</h2>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-lg">
                如果您在使用四虎影视大全过程中遇到任何问题，或有剧集推荐、合作咨询等需求，欢迎通过以下方式与我们取得联系。我们会在24小时内回复您的每一条消息。
              </p>
            </div>
            <div className="flex flex-col sm:flex-row items-center gap-4">
              <div className="flex items-center gap-3 px-5 py-3 rounded-xl bg-background-100/60 border border-background-300/30">
                <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500/15">
                  <i className="ri-mail-line text-primary-400"></i>
                </span>
                <span className="text-sm text-foreground-700">contact@sihumedia.com</span>
              </div>
              <div className="flex items-center gap-3 px-5 py-3 rounded-xl bg-background-100/60 border border-background-300/30">
                <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-accent-500/15">
                  <i className="ri-wechat-line text-accent-400"></i>
                </span>
                <span className="text-sm text-foreground-700">sihumedia</span>
              </div>
            </div>
          </div>

          <div className="absolute -top-20 -right-20 w-64 h-64 rounded-full bg-primary-500/5 blur-3xl pointer-events-none"></div>
          <div className="absolute -bottom-16 -left-16 w-48 h-48 rounded-full bg-accent-500/5 blur-3xl pointer-events-none"></div>
        </div>
      </div>
    </section>
  );
}